"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NumberInput", {
    enumerable: true,
    get: function() {
        return NumberInput;
    }
});
var _anatomy = require("@chakra-ui/anatomy");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var baseStyleRoot = {
    bg: "background-action-default",
    color: "text-primary"
};
var flushedStyleRoot = {
    bg: "background-action-default"
};
var fieldDisabledStyle = {
    bg: "background-action-disabled",
    borderColor: "ui-element-outline-disabled",
    opacity: 1,
    color: "text-secondary"
};
var baseStyleField = {
    borderColor: "none",
    border: "0.0625rem solid var(--chakra-colors-ui-element-outline-default)",
    borderRadius: "0.375rem",
    _placeholder: {
        color: "text-disabled"
    },
    _hover: {
        borderColor: "ui-element-outline-default",
        bg: "background-action-hover"
    },
    _focus: {
        bg: "background-action-default",
        borderColor: "none",
        border: "0.0625rem solid var(--chakra-colors-ui-element-outline-default)",
        boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
    },
    _invalid: {
        boxShadow: "none",
        border: "0.125rem solid",
        borderColor: "var(--chakra-colors-alert-error-default)"
    },
    _disabled: _object_spread_props(_object_spread({}, fieldDisabledStyle), {
        _hover: fieldDisabledStyle,
        _placeholder: {
            color: "text-disabled"
        }
    })
};
var flushedStyleField = {
    border: "none",
    borderBottom: "0.0625rem solid var(--chakra-colors-ui-element-outline-default)",
    _focus: {
        border: "none",
        borderBottom: "0.0625rem solid var(--chakra-colors-ui-element-outline-default)",
        bg: "background-action-default",
        boxShadow: "0 0.1875rem 0 0 var(--chakra-colors-primary-focus)"
    },
    _invalid: {
        border: "none",
        boxShadow: "0 0.125rem 0 0 var(--chakra-colors-alert-error-default)"
    }
};
var stepperGroupBorders = {
    _invalid: {
        borderLeft: "0.0625rem solid var(--chakra-colors-ui-element-outline-disabled)"
    },
    _disabled: {
        border: "0.0625rem solid  var(--chakra-colors-alert-error-default)",
        borderRightRadius: "0.3125rem"
    }
};
var baseStyleStepperGroup = function(param) {
    var isDisabled = param.isDisabled, isInvalid = param.isInvalid;
    return _object_spread({
        borderLeft: "0.0625rem solid var(--chakra-colors-ui-element-outline-default)"
    }, stepperGroupBorders[isDisabled && "_invalid"], stepperGroupBorders[isInvalid && "_disabled"]);
};
var flushedStyleStepperGroup = function(param) {
    var isInvalid = param.isInvalid;
    return {
        border: 0,
        margin: 0,
        height: isInvalid ? "100%" : "calc(100% - 0.0625rem)"
    };
};
var baseStyleStepper = {
    bg: "background-action-active",
    borderLeft: 0,
    borderColor: "ui-element-outline-default",
    _active: {
        bg: "background-action-pressed",
        color: "text-secondary"
    },
    _disabled: {
        bg: "background-action-disabled",
        color: "text-disabled"
    },
    _first: {
        borderTopEndRadius: "0.3125rem",
        opacity: 1
    },
    _last: {
        opacity: 1,
        borderBottomEndRadius: "0.3125rem",
        borderTopWidth: "0.0625rem",
        mt: "-0.0625rem",
        _disabled: {
            borderTopColor: "var(--chakra-colors-ui-element-outline-disabled)"
        }
    }
};
var flushedStyleStepper = {
    borderRadius: 0,
    _first: {
        borderTopEndRadius: 0
    },
    _last: {
        borderBottomEndRadius: 0
    }
};
var baseStyle = function(props) {
    return {
        root: baseStyleRoot,
        field: baseStyleField,
        stepperGroup: baseStyleStepperGroup(props),
        stepper: baseStyleStepper
    };
};
var flushedStyle = function(props) {
    return {
        root: flushedStyleRoot,
        field: flushedStyleField,
        stepperGroup: flushedStyleStepperGroup(props),
        stepper: flushedStyleStepper
    };
};
var calculatePaddings = {
    s: {
        py: "0.375rem",
        pl: "0.75rem",
        pr: "2.3125rem"
    },
    m: {
        py: "0.5rem",
        pl: "0.75rem",
        pr: "2.3125rem"
    },
    l: {
        py: "0.75rem",
        pl: "1rem",
        pr: "2.5625rem"
    }
};
var textStyles = {
    s: "text-body-meta-regular",
    m: "text-body-regular",
    l: "text-body-regular"
};
var calculateSize = function(size) {
    return {
        root: {
            textStyle: textStyles[size]
        },
        field: _object_spread_props(_object_spread({
            paddingStart: 0,
            paddingInlineStart: 0,
            paddingEnd: 0,
            paddingInlineEnd: 0
        }, calculatePaddings[size]), {
            _placeholder: {
                textStyle: textStyles[size]
            }
        })
    };
};
var sizes = {
    s: calculateSize("s"),
    m: calculateSize("m"),
    l: calculateSize("l")
};
var NumberInput = {
    parts: _anatomy.numberInputAnatomy.keys,
    baseStyle: baseStyle,
    variants: {
        outline: baseStyle,
        flushed: flushedStyle
    },
    sizes: sizes,
    defaultProps: {
        size: "m",
        variant: "outline"
    }
};
